var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    { attrs: { modalId: _vm.modalId, size: "modal-md" } },
    [
      _c(
        "ModalHeader",
        {
          style: { padding: "4px 12px" },
          attrs: {
            title: _vm.$t("xContactYourDealerModalHeader"),
            icon: "far fa-phone mr-1"
          }
        },
        [
          _c("div", { staticClass: "cols-auto" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-icon-button btn-icon-button--gray",
                attrs: { type: "button", "data-test-hook": "CloseModalBtn" },
                on: {
                  click: function($event) {
                    return _vm.closeModal(_vm.modalId)
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-times" })]
            )
          ])
        ]
      ),
      _c("ModalBody", [
        _c("div", { staticClass: "my-2" }, [
          _c("div", { staticClass: "mb-2" }, [
            _c("strong", [
              _vm._v(_vm._s(_vm.$t("xContactYourDealerModalInformation")) + ":")
            ])
          ]),
          _c("div", { staticClass: "mb-1" }, [
            _vm._v(_vm._s(_vm.dealerInfo.preferredDealerName))
          ]),
          _c("div", { staticClass: "mb-1" }, [
            _vm._v(_vm._s(_vm.dealerInfo.preferredDealerPhone))
          ]),
          _c("div", [_vm._v(_vm._s(_vm.dealerInfo.preferredDealerEmail))])
        ])
      ]),
      _c("ModalFooter", { staticClass: "py-1" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary text-sm ml-auto",
            attrs: { type: "button", "data-test-hook": "dealerContactDoneBtn" },
            on: {
              click: function($event) {
                return _vm.closeModal(_vm.modalId)
              }
            }
          },
          [_vm._v(" " + _vm._s(_vm.$t("xDone")) + " ")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }